




























































































































































import { Component, Vue } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import { KpiTargetsModule } from '@/store/modules/kpiTargets';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import KpiTargetDto from '@/models/KpiTargets/KpiTargetDto';
import { KPI_CODES, ENTITY_TYPES, getKpiLabel, getPeriodLabel, getKpiUnit, formatKpiValue } from '@/models/KpiTargets/KpiCodeRegistry';
import KpiTargetSidePanel from './KpiTargetSidePanel.vue';

@Component({
  name: 'KpiTargetList',
  components: { KpiTargetSidePanel }
})
export default class KpiTargetList extends GiganautVue {
  filterBranchId: string | null = null;
  filterDeskId: string | null = null;
  filterAgencyUserId: string | null = null;
  filterEntityType: number | null = null;
  filterKpiCode: string | null = null;
  filterActiveOnly = true;

  sidePanelVisible = false;
  selectedTarget: KpiTargetDto | null = null;
  deleteDialog = false;
  targetToDelete: KpiTargetDto | null = null;

  headers = [
    { text: 'KPI', value: 'kpiCode', sortable: true },
    { text: 'Scope', value: 'scope', sortable: false },
    { text: 'Period', value: 'periodType', sortable: true },
    { text: 'Target', value: 'targetValue', sortable: true },
    { text: 'Effective From', value: 'effectiveFrom', sortable: true },
    { text: 'Effective To', value: 'effectiveTo', sortable: true },
    { text: '', value: 'actions', sortable: false, width: '90px' },
  ];

  get loading() {
    return KpiTargetsModule.loading;
  }

  get kpiTargets() {
    return KpiTargetsModule.kpiTargets;
  }

  get branches() {
    return AgencySettingsModule.branches;
  }

  get filteredDesks() {
    if (!this.filterBranchId) {
      // Return all desks across all branches
      const allDesks: any[] = [];
      AgencySettingsModule.branches.forEach(b => {
        if (b.desks) {
          b.desks.forEach(d => allDesks.push(d));
        }
      });
      return allDesks;
    }
    const branch = AgencySettingsModule.branches.find(b => b.id === this.filterBranchId);
    return branch ? branch.desks || [] : [];
  }

  get agencyUserItems() {
    return AgencySettingsModule.agencyUsers.map(u => ({
      id: u.id,
      displayName: u.person ? u.person.firstName + ' ' + u.person.lastName : u.emailAddress,
    }));
  }

  get entityTypeItems() {
    return ENTITY_TYPES;
  }

  get filteredKpiCodeItems() {
    if (this.filterEntityType !== null && this.filterEntityType !== undefined) {
      return KPI_CODES.filter(k => k.entityType === this.filterEntityType);
    }
    return KPI_CODES;
  }

  getKpiLabel(code: string): string {
    return getKpiLabel(code);
  }

  getPeriodLabel(periodType: number): string {
    return getPeriodLabel(periodType);
  }

  getUserName(item: KpiTargetDto): string {
    if (item.agencyUser && item.agencyUser.person) {
      return item.agencyUser.person.firstName + ' ' + item.agencyUser.person.lastName;
    }
    return '-';
  }

  formatTargetValue(item: KpiTargetDto): string {
    const unit = getKpiUnit(item.kpiCode);
    return formatKpiValue(Number(item.targetValue), unit);
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  }

  async mounted() {
    if (AgencySettingsModule.branches.length === 0) {
      await AgencySettingsModule.getBranches();
    }
    if (AgencySettingsModule.agencyUsers.length === 0) {
      await AgencySettingsModule.getAgencyUsers();
    }
    await this.loadTargets();
  }

  async loadTargets() {
    await KpiTargetsModule.loadKpiTargets({
      branchId: this.filterBranchId || undefined,
      deskId: this.filterDeskId || undefined,
      agencyUserId: this.filterAgencyUserId || undefined,
      kpiCode: this.filterKpiCode || undefined,
      entityType: this.filterEntityType !== null ? this.filterEntityType : undefined,
      activeOnly: this.filterActiveOnly,
    });
  }

  onEntityTypeChanged() {
    // Clear KPI code if it no longer matches the selected entity type
    if (this.filterKpiCode && this.filterEntityType !== null) {
      const def = KPI_CODES.find(k => k.code === this.filterKpiCode);
      if (def && def.entityType !== this.filterEntityType) {
        this.filterKpiCode = null;
      }
    }
    this.loadTargets();
  }

  onBranchChanged() {
    if (this.filterBranchId) {
      this.filterAgencyUserId = null;
    }
    this.loadTargets();
  }

  onDeskChanged() {
    if (this.filterDeskId) {
      this.filterAgencyUserId = null;
    }
    this.loadTargets();
  }

  onUserChanged() {
    if (this.filterAgencyUserId) {
      this.filterBranchId = null;
      this.filterDeskId = null;
    }
    this.loadTargets();
  }

  onFilterChanged() {
    this.loadTargets();
  }

  openCreate() {
    this.selectedTarget = null;
    this.sidePanelVisible = true;
  }

  openEdit(target: KpiTargetDto) {
    this.selectedTarget = target;
    this.sidePanelVisible = true;
  }

  closeSidePanel() {
    this.sidePanelVisible = false;
    this.selectedTarget = null;
  }

  async onSaved() {
    this.closeSidePanel();
    await this.loadTargets();
  }

  confirmDelete(target: KpiTargetDto) {
    this.targetToDelete = target;
    this.deleteDialog = true;
  }

  async doDelete() {
    if (this.targetToDelete) {
      const success = await KpiTargetsModule.deleteKpiTarget(this.targetToDelete.id);
      if (success) {
        await this.loadTargets();
      }
    }
    this.deleteDialog = false;
    this.targetToDelete = null;
  }
}
